export default "__VITE_ASSET__fbd584c8__"